module.exports = __webpack_public_path__ + "img/COMBO HEART LIME.4de5357.svg";